import SectionHeader from '@/components/feature/SectionHeader';
import MovieCard from '@/components/feature/MovieCard';
import { getLatestMovies } from '@/mocks/movies';

export default function LatestSection() {
  const latest = getLatestMovies();

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          title="最新上线"
          subtitle="追剧不停，新鲜出炉的热门内容"
          linkTo="/category/tv"
          linkLabel="更多新剧"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop>
          {latest.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}